// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___1nhrH","childrenContainer":"styles__childrenContainer___1kXw8","timeframeContainer":"styles__timeframeContainer___3uxmB","timeframeLabel":"styles__timeframeLabel___2dw7a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/categoryTabs/categoryTabBodyTimeframe/styles.css
// module id = 882
// module chunks = 0